import { RecognizeVipCriterion } from "@redotech/redo-recognize-common/vip-profile";
import * as z from "zod";

const Summary = z.object({
  headline: z.string(),
  description: z.string(),
  updatedAt: z.string().nullable(),
});

const Distribution = z.array(
  z.object({
    label: z.string(),
    count: z.number().int().nonnegative(),
    percentage: z.number().min(0).max(100),
  }),
);

export const getRecognizeAudienceInsights = {
  name: "getRecognizeAudienceInsights" as const,
  input: z.object({
    segment: z.enum(["all", "vips", ...RecognizeVipCriterion.options]),
  }),
  output: z.object({
    audienceProfile: z
      .object({
        summary: Summary.nullable(),
        identifiedCustomers: z.number().int().nonnegative(),
        vipCustomers: z.number().int().nonnegative(),
      })
      .nullable(),
    industrySummary: Summary.nullable(),
    homeValueSummary: Summary.nullable(),
    whereTheyLive: Summary.nullable(),
    homeValue: Distribution.nullable(),
    industries: Distribution.nullable(),
    gender: Distribution.nullable(),
    customerConcentration: z
      .array(
        z.object({
          city: z.string(),
          regionCode: z.string().nullable(),
          countryCode: z.string(),
          latitude: z.number().nullable(),
          longitude: z.number().nullable(),
          count: z.number().int().nonnegative(),
        }),
      )
      .nullable(),
    vips: z
      .object({
        summary: Summary.nullable(),
        count: z.number().int().nonnegative(),
        percentage: z.number().min(0).max(100),
      })
      .nullable(),
    vipTypes: z
      .array(
        z.object({
          criterion: RecognizeVipCriterion,
          count: z.number().int().nonnegative(),
          percentage: z.number().min(0).max(100),
        }),
      )
      .nullable(),
  }),
};

export type RecognizeAudienceInsights = z.infer<
  typeof getRecognizeAudienceInsights.output
>;
export type RecognizeAudienceSegment = z.infer<
  typeof getRecognizeAudienceInsights.input
>["segment"];
